import Vue from 'vue'
import Router from 'vue-router'
// import Index from '@/page/index'
Vue.use(Router)
export default new Router({
    routes: [{
            path: '/',
            redirect: '/index',
            component: resolve => require(['@/page/home'], resolve),
            children: [{
                    // 关于
                    path: '/about',
                    name: '',
                    component: resolve => require(['@/page/about'], resolve),
                },
                {
                    // 招聘
                    path: '/recruit',
                    name: '',
                    component: resolve => require(['@/page/recruit'], resolve),
                },
                {
                    // 蜜链盟
                    path: '/mlm',
                    name: '',
                    component: resolve => require(['@/page/mlm'], resolve),
                },
                {
                    // 乡村振兴
                    path: '/village',
                    name: '',
                    component: resolve => require(['@/page/village'], resolve),
                },
                {
                    // 神椰
                    path: '/shenye',
                    name: '',
                    component: resolve => require(['@/page/shenye'], resolve),
                },
                //渠道合作及特色案例
                {
                    path: '/characteristic-cases',
                    name: '',
                    component: resolve => require(['@/page/characteristic-cases'], resolve),
                },
                //资讯中心首页
                {
                    path: '/news/index',
                    name: 'news/index',
                    props: true,
                    component: resolve => require(['@/page/news/index'], resolve),
                },
                //更多资讯
                {
                    path: '/news/index-more',
                    name: '',
                    component: resolve => require(['@/page/news/index-more'], resolve),
                },
                //资讯详情
                {
                    path: '/news/details',
                    name: '',
                    component: resolve => require(['@/page/news/details'], resolve),
                    // path: '/news/details',
                    // name: 'details',
                },
                {
                    //首页
                    path: '/index',
                    component: resolve => require(['@/page/index'], resolve),
                },

            ]

        },


    ],
    scrollBehavior: () => ({ y: 0 })
})


// WEBPACK FOOTER //
// ./src/router/index.js